import { getLegacyUrl } from '@/src/general/utils/getLegacyUrl'

export const getAdminWebViewScript = (token: string | null) => `
  (function() {
    if (window.location.origin !== ${JSON.stringify(new URL(getLegacyUrl('/')).origin)}) return;
    var token = ${JSON.stringify(token)};
    var key = ${JSON.stringify('hozana\\token')};
    window.localStorage.removeItem(${JSON.stringify('hozana\\me')});
    if (token) {
      window.localStorage.setItem(key, JSON.stringify(token));
      document.cookie = 'jwtToken=' + encodeURIComponent(token) + '; Path=/; SameSite=Lax; Secure';
    } else {
      window.localStorage.removeItem(key);
      document.cookie = 'jwtToken=; Path=/; Max-Age=0';
    }
    // Android does not report SPA pushState/replaceState through onNavigationStateChange.
    if (!window.__hozanaAdminNavigationInstalled) {
      window.__hozanaAdminNavigationInstalled = true;
      var notifyNavigation = function() {
        window.ReactNativeWebView.postMessage(window.location.href);
      };
      ['pushState', 'replaceState'].forEach(function(method) {
        var original = window.history[method];
        window.history[method] = function() {
          var result = original.apply(this, arguments);
          notifyNavigation();
          return result;
        };
      });
      window.addEventListener('popstate', notifyNavigation);
    }
  })();
  true;
`
